varying vec3 vColor;
varying float vAlpha;
uniform float opacity;

uniform float glowIntensity;   
uniform float coreSharpness;   

void main() {
    vec2 uv = gl_PointCoord - vec2(0.5);
    float dist = length(uv);

    float core = pow(1.0 - smoothstep(0.0, 0.5, dist), coreSharpness);

    float halo = smoothstep(0.5, 0.0, dist);

    float a = (core + halo * glowIntensity) * vAlpha * opacity;

    gl_FragColor = vec4(vColor, a);
}
